export const scrollWithOffset = (id, offset = 0) => {
    if (id) {
        const y = id.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: y, behavior: "instant" })
    }
}
